import { render, staticRenderFns } from "./MainSidebarMenuItemsIterator.vue?vue&type=template&id=6bd0b8e0&"
import script from "./MainSidebarMenuItemsIterator.vue?vue&type=script&lang=ts&"
export * from "./MainSidebarMenuItemsIterator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports